import React from 'react';
import anchorme from 'anchorme';
import { ButtonAction, scrollElementIntoView, ShadowPosition } from 'containers/PageBuilder/SinglePageContainer/domain';
import BlockContainer from '../BlockComponents/BlockContainer';
import styled from 'styled-components';
import BlockContentContainer from '../BlockComponents/BlockContentContainer';
import BlockImage from '../BlockComponents/BlockImage';
import BlockTextContainer, { BlockSubTextContainer } from '../BlockComponents/BlockTextContainer';
import BlockButton from '../BlockComponents/BlockButton';
import { IImageTextColumnBlockPreviewProps } from './IImageTextColumnBlockPreviewProps';
import { isValidHexColor } from 'components/PageBuilder/PageBuilderSideBar/BlockSettings/domain';
import miscUtils from 'utils/miscUtils';
import { BlockButtonsContainer, BlockSideButton } from '../ButtonBlockPreview/ButtonBlockPreview';

const ImageTextColumnBlockContainer: any = styled(BlockContainer)`
    &.mobile {
        padding-left: 15px;
        padding-right: 15px;
    }

    @media(max-width: 550px) {
        padding-left: 15px;
        padding-right: 15px; 
    }
`;

const ImageTextColumnBlockContentContainer: any = styled(BlockContentContainer)`
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    background-color: ${(props: any) => 
        props.design.column_container_background_color &&
        isValidHexColor(props.design.column_container_background_color) ?
        props.design.column_container_background_color :
        'transparent'
    };
    padding-top: ${(props: any) => 
        props.design.column_container_padding_top ?
        `${props.design.column_container_padding_top}px` :
        `0px`
    };
    padding-bottom: ${(props: any) => 
        props.design.column_container_padding_bottom ?
        `${props.design.column_container_padding_bottom}px` :
        `0px`
    };
    padding-left: ${(props: any) => 
        props.design.column_container_padding_left ?
        `${props.design.column_container_padding_left}px` :
        `0px`
    };
    padding-right: ${(props: any) => 
        props.design.column_container_padding_right ?
        `${props.design.column_container_padding_right}px` :
        `0px`
    };
    border-radius: ${(props: any) => 
        props.design.column_container_border_radius &&
        props.design.column_container_border_radius <= 30 ?
        `${props.design.column_container_border_radius}px`:
        `4px`
    };
    border: ${(props: any) => 
        props.design.column_container_border_color &&
        isValidHexColor(props.design.column_container_border_color) ?
        `${
            props.design.column_container_border_width ?
            props.design.column_container_border_width : 
            1
        }px solid ${props.design.column_container_border_color}` :
        `${
            props.design.column_container_border_width ?
            props.design.column_container_border_width : 
            1
        }px solid #D5D8DF`
    };
    box-shadow: ${(props: any) => 
        props.design.column_container_shadow_color &&
        isValidHexColor(props.design.column_container_shadow_color) ?
        props.design.column_container_shadow_position === ShadowPosition.Even ?
        `0px 0px 8px rgba(${miscUtils.hexToRgb(props.design.column_container_shadow_color)!.r}, ${miscUtils.hexToRgb(props.design.column_container_shadow_color)!.g}, ${miscUtils.hexToRgb(props.design.column_container_shadow_color)!.b}, ${props.design.column_container_shadow_opacity ? props.design.column_container_shadow_opacity : 0.0})` :
        props.design.column_container_shadow_position === ShadowPosition.Bottom ?
        `0px 4px 8px rgba(${miscUtils.hexToRgb(props.design.column_container_shadow_color)!.r}, ${miscUtils.hexToRgb(props.design.column_container_shadow_color)!.g}, ${miscUtils.hexToRgb(props.design.column_container_shadow_color)!.b}, ${props.design.column_container_shadow_opacity ? props.design.column_container_shadow_opacity : 0.0})` :
        props.design.column_container_shadow_position === ShadowPosition.Top ?
        `0px -4px 8px rgba(${miscUtils.hexToRgb(props.design.column_container_shadow_color)!.r}, ${miscUtils.hexToRgb(props.design.column_container_shadow_color)!.g}, ${miscUtils.hexToRgb(props.design.column_container_shadow_color)!.b}, ${props.design.column_container_shadow_opacity ? props.design.column_container_shadow_opacity : 0.0})` :
        props.design.column_container_shadow_position === ShadowPosition.BottomRight ?
        `2px 4px 8px rgba(${miscUtils.hexToRgb(props.design.column_container_shadow_color)!.r}, ${miscUtils.hexToRgb(props.design.column_container_shadow_color)!.g}, ${miscUtils.hexToRgb(props.design.column_container_shadow_color)!.b}, ${props.design.column_container_shadow_opacity ? props.design.column_container_shadow_opacity : 0.0})` :
        props.design.column_container_shadow_position === ShadowPosition.BottomLeft ?
        `-2px 4px 8px rgba(${miscUtils.hexToRgb(props.design.column_container_shadow_color)!.r}, ${miscUtils.hexToRgb(props.design.column_container_shadow_color)!.g}, ${miscUtils.hexToRgb(props.design.column_container_shadow_color)!.b}, ${props.design.column_container_shadow_opacity ? props.design.column_container_shadow_opacity : 0.0})` :
        props.design.column_container_shadow_position === ShadowPosition.TopRight ?
        `2px -4px 8px rgba(${miscUtils.hexToRgb(props.design.column_container_shadow_color)!.r}, ${miscUtils.hexToRgb(props.design.column_container_shadow_color)!.g}, ${miscUtils.hexToRgb(props.design.column_container_shadow_color)!.b}, ${props.design.column_container_shadow_opacity ? props.design.column_container_shadow_opacity : 0.0})` :
        props.design.column_container_shadow_position === ShadowPosition.TopLeft ?
        `-2px -4px 8px rgba(${miscUtils.hexToRgb(props.design.column_container_shadow_color)!.r}, ${miscUtils.hexToRgb(props.design.column_container_shadow_color)!.g}, ${miscUtils.hexToRgb(props.design.column_container_shadow_color)!.b}, ${props.design.column_container_shadow_opacity ? props.design.column_container_shadow_opacity : 0.0})` :
        'none'
        :
        'none'
    };

    
    &.right {
        flex-direction: row-reverse;
    }

    &.mobile {
        flex-direction: column;
        padding-left: 15px;
        padding-right: 15px;
        padding-top: 15px;
        padding-bottom: 15px;

        justify-content: center;

        &.right {
            flex-direction: column-reverse;

            justify-content: center;
        }
    }

    @media(max-width: 801px) {
        flex-direction: column;
        padding-left: 15px;
        padding-right: 15px;
        padding-top: 15px;
        padding-bottom: 15px;

        justify-content: center

        &.right {
            flex-direction: column-reverse;

            justify-content: center;
        }
    }
`;

const ImageTextBlockImage: any = styled(BlockImage)`
    width: ${(props: any) =>
        props.design.image_width ? 
        `${props.design.image_width}px` : 
        `100%`
    };
    max-width: 448px;

    &.mobile {
        max-width: 100%;
    }

    @media(max-width: 801px) {
        max-width: 100%;
    }
`;

export const ImageTextBlockGutter: any = styled.div`
    min-width: 20px;

    &.mobile {
        min-height: 10px;
    }

    @media(max-width: 801px) {
        min-height: 10px;
    }
`;

export const ImageTextBlockTextContainer: any = styled.div<{design: any}>`
    width: 100%;
    padding: 24px 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: ${(props: any) => 
        props.design.text_alignment === 'left' ?
        `flex-start` :
        props.design.text_alignment === 'right' ?
        `flex-end` :
        props.design.text_alignment
    }

    &.mobile {
        padding: 0;
    }

    @media(max-width: 801px) {
        padding: 0;
    }
`;

const ImageTextBlockPreview: React.FC<IImageTextColumnBlockPreviewProps> = (props) => {

    const onClickImage = () => {
        if(props.buildingPreview) {
            return;
        }
        
        if(
            props.blockData &&
            (
                !props.blockData.image_action ||
                props.blockData.image_action === ButtonAction.URL ||
                props.blockData.image_action === ButtonAction.URLTab
            ) &&
            props.blockData.image_link
        ) {
            window.open(
                miscUtils.ensureHttps(props.blockData.image_link), 
                props.blockData.image_action === ButtonAction.URL ?
                '_self' :
                '_blank'
            );
            return;
        }
    
        if(
            props.blockData &&
            props.blockData.image_action === ButtonAction.Scroll &&
            props.blockData.image_link &&
            props.containerBaseIdName
        ) {
            scrollElementIntoView(`${props.containerBaseIdName}${props.blockData.image_link}`);
            return;
        }
    
        if(
            props.blockData &&
            props.blockData.image_action === ButtonAction.Popup &&
            props.blockData.image_link
        ) {
            let nextPageFormsOpenState = JSON.parse(JSON.stringify(props.pageFormsOpenState));
    
            nextPageFormsOpenState[props.blockData.image_link] = true;
    
            props.setPageFormsOpenState(nextPageFormsOpenState);
            return;
        }

        if(
            props.blockData &&
            props.blockData.image_action === ButtonAction.Page &&
            props.blockData.image_link
        ) {
            window.open(
                `${props.blockData.image_link}`, 
                '_self'
            );
            return;
        }
    }

    const ctaOnClick = (blockData: any) => {
        if(props.buildingPreview) {
            return;
        }

        if(
            blockData &&
            (
                blockData.button_action === ButtonAction.URL ||
                blockData.button_action === ButtonAction.URLTab
            ) &&
            blockData.button_url
        ) {
            window.open(
                miscUtils.ensureHttps(blockData.button_url), 
                blockData.button_action === ButtonAction.URLTab ?
                '_blank' :
                '_self'
            );
            return;
        }

        if(
            blockData &&
            blockData.button_action === ButtonAction.Scroll &&
            blockData.button_url &&
            props.containerBaseIdName
        ) {
            scrollElementIntoView(`${props.containerBaseIdName}${blockData.button_url}`);
            return;
        }

        if(
            blockData &&
            blockData.button_action === ButtonAction.Popup &&
            blockData.button_url
        ) {
            let nextPageFormsOpenState = JSON.parse(JSON.stringify(props.pageFormsOpenState));

            nextPageFormsOpenState[blockData.button_url] = true;

            props.setPageFormsOpenState(nextPageFormsOpenState);
            return;
        }

        if(
            blockData &&
            blockData.button_action === ButtonAction.Page &&
            blockData.button_url
        ) {
            window.open(
                `${blockData.button_url}`,
                '_self'
            );
            return;
        }
    }

  return (
    <ImageTextColumnBlockContainer
    className={`${props.view ? props.view : ''}`}
    design={props.blockData.design}
    >
        <ImageTextColumnBlockContentContainer
        className={`${props.blockData.image_layout} ${props.view ? props.view : ''}`}
        design={props.blockData.design}
        >
            {props.blockData.image_shown ? (
                <>
                <ImageTextBlockImage
                className={`${props.view ? props.view : ''}`}
                design={props.blockData.design}
                src={props.blockData.image_url}
                alt={props.blockData.image_alt}
                onClick={onClickImage}
                clickable={props.blockData.image_link && props.blockData.image_link.trim() !== "#"}
                />
    
                <ImageTextBlockGutter
                className={`${props.view ? props.view : ''}`}
                />
                </>
            ) : <></>}

            <ImageTextBlockTextContainer
            className={`${props.blockData.image_layout} ${props.view ? props.view : ''}`}
            design={props.blockData.design}
            >
                <BlockTextContainer
                design={props.blockData.design}
                pageStyles={props.pageStyles}
                textKey="heading"
                dangerouslySetInnerHTML={{
                    __html: anchorme(props.blockData.heading),
                }}
                />

                <BlockSubTextContainer
                design={props.blockData.design}
                pageStyles={props.pageStyles}
                textKey="subtext"
                dangerouslySetInnerHTML={{
                    __html: anchorme(props.blockData.subtext),
                }}
                />

                {props.blockData.button_shown ? (
                    <BlockButtonsContainer
                    className={`${props.view ? props.view : ''}`}
                    >
                        <BlockButton
                        design={props.blockData.design}
                        pageStyles={props.pageStyles}
                        onClick={() => ctaOnClick(props.blockData)}
                        >
                            {props.blockData.button_text}
                        </BlockButton>
        
                        {props.blockData.side_by_side_buttons ? (
                            props.blockData.side_by_side_buttons.map((side_by_side_button: any, index: number) => (
                                <BlockSideButton
                                key={`${index}`}
                                className={`${props.view ? props.view : ''}`}
                                design={side_by_side_button.design}
                                pageStyles={props.pageStyles}
                                onClick={() => ctaOnClick(side_by_side_button)}
                                >
                                    {side_by_side_button.button_text}
                                </BlockSideButton>
                            ))
                        ) : <></>}
                    </BlockButtonsContainer>
                ) : <></>}
            </ImageTextBlockTextContainer>
        </ImageTextColumnBlockContentContainer>
    </ImageTextColumnBlockContainer>
  )
}

export default ImageTextBlockPreview;